define("auth/routes/o-auth", ["exports", "@ember/routing/route", "later/utils/fetch"], function (_exports, _route, _fetch) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/routing/route",0,"later/utils/fetch"eaimeta@70e063a35619d71f
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  class OAuthRoute extends _route.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "queryParams", {
        redirect: {},
        // Redirect address
        authenticity_token: {},
        client_id: {},
        redirect_uri: {},
        state: {},
        response_type: {},
        scope: {},
        code_challenge: {},
        code_challenge_method: {},
        referer: {},
        error: {},
        error_description: {}
      });
    }
    setupController(controller, model) {
      super.setupController(controller, model);
      controller.setProperties({
        payload: model.params,
        appDetails: model.oauthApp
      });
    }
    async model(params) {
      let oauthApp = {};
      const {
        client_id
      } = params;
      if (client_id) {
        const applicationDetailsUrl = `/api/v2/oauth_applications/${client_id}`;
        try {
          oauthApp = await (0, _fetch.fetch)(applicationDetailsUrl, {
            method: 'get'
          });
        } catch (error) {
          // TODO: add proper error handling should fetching details fail
          console.error('Error coccured fetching SSO app details');
          console.error(error);
        }
      }
      return {
        oauthApp,
        params
      };
    }
  }
  _exports.default = OAuthRoute;
});